import { Link } from "react-router-dom";
import { useSiteSettings } from "@/contexts/SettingsContext";

export default function Footer() {
  const { settings } = useSiteSettings();
  const appName = settings?.app_name || "";
  const text = settings?.footer_text || `© ${new Date().getFullYear()} ${appName}. Tous droits réservés.`;
  const contact = settings?.contact_email || "";
  const links = Array.isArray(settings?.footer_links) ? settings.footer_links : [];
  const terms = settings?.terms_url || "";
  const privacy = settings?.privacy_url || "";

  return (
    <footer className="mt-16 border-t border-zinc-200 bg-zinc-50" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          <div>
            <p className="font-heading text-base font-bold text-zinc-900 mb-2">{appName}</p>
            <p className="text-zinc-500 leading-relaxed">{text}</p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-400 mb-2">Liens</p>
            <ul className="space-y-1.5 text-zinc-600">
              <li><Link to="/spaces" className="hover:text-emerald-700">Explorer les terrains</Link></li>
              <li><Link to="/create-space" className="hover:text-emerald-700">Devenir hôte</Link></li>
              <li><Link to="/subscription" className="hover:text-emerald-700">Abonnement hôte</Link></li>
              {links.map((l, i) => (
                <li key={`${l.url}-${l.label}-${i}`}><a href={l.url} className="hover:text-emerald-700" target="_blank" rel="noopener noreferrer">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-400 mb-2">Legal</p>
            <ul className="space-y-1.5 text-zinc-600">
              <li><Link to="/cgu" className="hover:text-emerald-700" data-testid="footer-cgu-link">Conditions d'utilisation</Link></li>
              <li><Link to="/confidentialite" className="hover:text-emerald-700" data-testid="footer-privacy-link">Politique de confidentialité</Link></li>
              <li><Link to="/annulation" className="hover:text-emerald-700" data-testid="footer-cancellation-link">Politique d'annulation</Link></li>
              {terms && <li><a href={terms} className="hover:text-emerald-700" target="_blank" rel="noopener noreferrer">CGU (lien externe)</a></li>}
              {privacy && <li><a href={privacy} className="hover:text-emerald-700" target="_blank" rel="noopener noreferrer">Confidentialité (lien externe)</a></li>}
              {contact && <li><a href={`mailto:${contact}`} className="hover:text-emerald-700">{contact}</a></li>}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
